import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Avatar, Box, Button, IconButton, Typography, useTheme, Tooltip } from "@mui/material";
import React from 'react';

const SingleNotification = ({ message, time, onClose, navigate }) => {
    const theme = useTheme();

    const convertDate = timedate => {
        const date = new Date(timedate);
        const now = new Date();

        const timeDifference = now - date;
        const secondsDifference = Math.floor(timeDifference / 1000);
        const minutesDifference = Math.floor(secondsDifference / 60);
        const hoursDifference = Math.floor(minutesDifference / 60);
        const daysDifference = Math.floor(hoursDifference / 24);
        const weeksDifference = Math.floor(daysDifference / 7);
        const monthsDifference =
            now?.getMonth() -
            date?.getMonth() +
            12 * (now?.getFullYear() - date?.getFullYear());
        const yearsDifference = Math.floor(monthsDifference / 12);

        if (yearsDifference > 0) {
            return `${yearsDifference}y ago`;
        } else if (monthsDifference > 0) {
            return `${monthsDifference}mo ago`;
        } else if (weeksDifference > 0) {
            return `${weeksDifference}w ago`;
        } else if (daysDifference > 0) {
            return `${daysDifference}d ago`;
        } else if (hoursDifference > 0) {
            return `${hoursDifference}h ago`;
        } else if (minutesDifference > 0) {
            return `${minutesDifference}m ago`;
        } else {
            return 'just now';
        }
    };

    return (
        <Box className="notification" sx={{ position: 'relative' }}>
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                <Avatar
                    sx={{
                        width: 36,
                        height: 36,
                        bgcolor: theme.palette.primary.main + '20',
                        color: theme.palette.primary.main,
                        border: `1px solid ${theme.palette.primary.main}40`,
                        fontSize: '1rem'
                    }}
                >
                    <img
                        src={`https://api.dicebear.com/7.x/identicon/svg?seed=${message?.length}`}
                        alt="N"
                        style={{ width: '100%', height: '100%' }}
                    />
                </Avatar>
                
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.primary',
                            fontSize: '0.875rem',
                            lineHeight: 1.4,
                            fontWeight: 500,
                            mb: 0.5,
                            wordBreak: 'break-word',
                        }}
                    >
                        {message}
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '0.75rem',
                                color: 'text.secondary',
                                fontWeight: 400
                            }}
                        >
                            {convertDate(time)}
                        </Typography>
                        
                        <Button
                            size="small"
                            onClick={(e) => { e.stopPropagation(); navigate(); }}
                            startIcon={<VisibilityIcon sx={{ fontSize: '14px !important' }} />}
                            sx={{
                                p: 0,
                                minWidth: 0,
                                color: 'primary.main',
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                fontWeight: 600,
                                '&:hover': {
                                    background: 'transparent',
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            View
                        </Button>
                    </Box>
                </Box>

                <Tooltip title="Dismiss">
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); onClose(); }}
                        sx={{
                            p: 0.5,
                            color: 'text.disabled',
                            mt: -0.5,
                            '&:hover': {
                                color: 'error.main',
                                bgcolor: 'error.main' + '10'
                            }
                        }}
                    >
                        <CloseIcon sx={{ fontSize: '16px' }} />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default SingleNotification;
